import strings from './strings'
import images from './imagesAsset'
const R = {
  strings,
  images,
}
export default R
